module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Influencer Handle")]), _vm._v(" "), (_vm.inputedRates.instagramHandle) ? _c('social-handle', {
    attrs: {
      "isInstagram": true,
      "instagramHandle": _vm.inputedRates.instagramHandle
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.inputedRates.instagramHandle) ? _c('div', [_vm._v("-")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Tiktok Handle")]), _vm._v(" "), (_vm.inputedRates.tiktokHandle) ? _c('social-handle', {
    attrs: {
      "isTikTok": true,
      "tiktokHandle": _vm.inputedRates.tiktokHandle
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.inputedRates.tiktokHandle) ? _c('div', [_vm._v("-")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('tbody', [_c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Story")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.inputedRates.igStory || '-'))]), _vm._v(" "), (_vm.inputedRates.igStory) ? _c('span', [_vm._v("$ SGD")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Post")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.inputedRates.igPost || '-'))]), _vm._v(" "), (_vm.inputedRates.igPost) ? _c('span', [_vm._v("$ SGD")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Carousel")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.inputedRates.igCarousel || '-'))]), _vm._v(" "), (_vm.inputedRates.igCarousel) ? _c('span', [_vm._v("$ SGD")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Video")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.inputedRates.igVideo || '-'))]), _vm._v(" "), (_vm.inputedRates.igVideo) ? _c('span', [_vm._v("$ SGD")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Reel")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.inputedRates.igReel || '-'))]), _vm._v(" "), (_vm.inputedRates.igReel) ? _c('span', [_vm._v("$ SGD")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("Loading Fee")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.inputedRates.loadingFee || '-'))]), _vm._v(" "), (_vm.inputedRates.loadingFee) ? _c('span', [_vm._v("$ SGD")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("Event Appearance")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.inputedRates.eventAppearance || '-'))]), _vm._v(" "), (_vm.inputedRates.eventAppearance) ? _c('span', [_vm._v("$ SGD")]) : _vm._e()])])])]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Remark (Instagram)")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.inputedRates.igRemarks || '-'))])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-flex mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-simple-table', {
    staticClass: "tiktok-stats",
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('tbody', [_c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("Tiktok")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.inputedRates.tiktok || '-'))]), _vm._v(" "), (_vm.inputedRates.tiktok) ? _c('span', [_vm._v("$ SGD")]) : _vm._e()])])])]
      },
      proxy: true
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Remark (TikTok)")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.inputedRates.tiktokRemarks || '-'))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-divider', {
    staticClass: "ma-0"
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Handle of Other Platforms")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Platform")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("URL")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Rate")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.inputedRates.platforms), function(item, index) {
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v("\n                    " + _vm._s(item.platform) + "\n                    "), (item.platform === 'others') ? _c('span', [_vm._v(_vm._s(item.otherPlatform))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.url))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(item.rate))]), _vm._v(" "), (item.rate) ? _c('span', [_vm._v("$ SGD")]) : _vm._e()])])
        }), 0)]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("About You")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.inputedRates.aboutYou || '-') + "\n          ")])]), _vm._v(" "), (_vm.inputedRates.pricingDecks && _vm.inputedRates.pricingDecks.length > 0) ? _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Media Kit")]), _vm._v(" "), _c('file-preview', {
    attrs: {
      "files": _vm.inputedRates.pricingDecks
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c929909"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/InputedRates.vue
// module id = 2021
// module chunks = 0